import { createFeatureSelector, createSelector } from "@ngrx/store";
import { pumpUnitFeatureKey } from "./pump-unit.reducer";

export const selectPumpUnitState = createFeatureSelector(pumpUnitFeatureKey);

export const selectPumpUnit = createSelector(
  selectPumpUnitState,
  (state: any) => state
);